<template lang="html">

  <section class="footer row-center">
    <div class="container row-between" show="true">
      <rrss></rrss>
      <div class="otros-enlaces row-between">
        <nav>
          <router-link :to="$t('enlaces.politica_proteccion')">{{ $t('vistas.politica_proteccion') }}</router-link>
          <router-link :to="$t('enlaces.politica_cookies')">{{ $t('vistas.politica_cookies') }}</router-link>
          <router-link :to="$t('enlaces.datos_seguros')">{{ $t('vistas.datos_seguros') }}</router-link>
          <router-link :to="$t('enlaces.aviso_legal')">{{ $t('vistas.aviso_legal') }}</router-link>
          <!-- <router-link :to="$t('enlaces.mapa_web')">{{$t('vistas.mapa_web')}}</router-link> -->
        </nav>
      </div>
    </div>
    <governmental></governmental>
  </section>

</template>

<script lang="js">


  import rrss from '@/components/parts/rrss'
  import governmental from '@/components/parts/governmental'

  export default {
    name: 'app-footer',
    components: {

      'rrss': rrss,
      'governmental': governmental
    }
  }
</script>

<style scoped lang="scss">
  @import "@/assets/css/colors.scss";

  .footer {
    width: 100%;
  /*   position: absolute; */
    left: 0;
    bottom: 0;
    background: $plum;
    z-index: 27;
    height: 160px;
  }

  .footer .container {
    height: 70px;
  }

  p {
    width: auto;
  }

  .otros-enlaces a {
    margin-right: 10px;
  }

  @media screen and (max-width: 830px) {
    .footer {
      height: auto;
      padding: 25px 0px;
      z-index: 45;
      position: initial;

      .container {
        -webkit-flex-direction: column;
        -moz-flex-direction: column;
        -ms-flex-direction: column;
        -o-flex-direction: column;
        flex-direction: column;

        .rrss {
          margin-bottom: 10px;
        }
      }
    }

    .otros-enlaces a {
      font-size: 12px;
      margin-right: 5px;
    }

    .footer .container {

      flex-direction: column;
      display: flex;
      flex-wrap: nowrap;
    }

    .rrss {
      width: 100%;
    }

    .otros-enlaces {
      width: 100%
    }


  }
</style>


// WEBPACK FOOTER //
// src/components/parts/footer.vue